import { useInputState } from './useInputState';
import { validateEmailFormat, validateMissingEmail, validateEmailLength } from '../email';

const getValidations = (isOptional, validationType) => [
  {
    validate: (value) => validateMissingEmail(value, isOptional),
    errorMessage: 'pleaseEnterEmail'
  },
  {
    validate: (value) => validateEmailFormat(value, isOptional, validationType),
    errorMessage: 'invalidEmail'
  },
  {
    validate: (value) => validateEmailLength(value),
    errorMessage: 'invalidEmailLength'
  }
];

export function useEmailInputState(options, isOptional = false, validationType) {
  const { validations: additionalValidations = [], ...restOptions } = options || {};
  return useInputState({
    initialValue: '',
    validations: [
      ...getValidations(isOptional, validationType),
      ...(additionalValidations || [])
    ],
    ...(restOptions || {})
  });
}
